import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_32aa2cdc-2128-46e1-b78d-17029247dee5/artifacts/q6wuaspw_ChatGPT%20Image%20Feb%203%2C%202026%2C%2006_33_23%20PM.png";

const navLinks = [
  { name: "Services", href: "#services" },
  { name: "Contact", href: "#contact" },
];

const Navbar = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-nav shadow-sm" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Ultimate Caulking Co"
              className="h-14 w-14 object-contain"
            />
            <span className="ml-3 font-heading text-xl font-bold text-[#0a0a0a] hidden sm:block">
              ULTIMATE CAULKING
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="font-medium text-[#171717] hover:text-[#525252] transition-colors text-sm tracking-wide"
                data-testid={`nav-${link.name.toLowerCase()}`}
              >
                {link.name.toUpperCase()}
              </a>
            ))}
            <Button
              className="bg-[#0a0a0a] text-white hover:bg-[#171717] font-heading tracking-wider"
              onClick={(e) => scrollToSection(e, "#contact")}
              data-testid="nav-get-quote-btn"
            >
              <Phone className="w-4 h-4 mr-2" />
              GET QUOTE
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[#0a0a0a]" />
            ) : (
              <Menu className="w-6 h-6 text-[#0a0a0a]" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#e5e5e5]" data-testid="mobile-menu">
            <nav className="py-4 space-y-2">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="block px-4 py-3 font-medium text-[#171717] hover:bg-[#f5f5f5] transition-colors"
                  data-testid={`mobile-nav-${link.name.toLowerCase()}`}
                >
                  {link.name.toUpperCase()}
                </a>
              ))}
              <div className="px-4 pt-2">
                <Button
                  className="w-full bg-[#0a0a0a] text-white hover:bg-[#171717] font-heading tracking-wider"
                  onClick={(e) => scrollToSection(e, "#contact")}
                  data-testid="mobile-get-quote-btn"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  GET QUOTE
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
